<template>
    <div></div>
</template>
<script>

    export default {
        data () {
            return {
                modalClass: "",
                resource: {}
            }
        },
        mounted: function(){

            self = this
            setTimeout(function(){
                self.modalClass = "show";
                self.resourceLoaded();
            }, 50);
        },
        methods:{
            back: function(){
                self = this
                if( this.modalClass == "show" ){
                    this.modalClass = "hide";
                    setTimeout(function(){
                        self.$router.push({name: self.getResource().name});
                    }, 500);
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/layouts/Import.vue